import { LocationCard } from '@components/location-picker';
import { createFormField } from '../common';

export const HQLocationField = createFormField(LocationCard);
